import type { PlanId, UserProfile } from "@/types/mentors";

export function deriveBrowseOnly(planId?: PlanId, roles: string[] = []): boolean {
  // admins bypass
  if (roles.includes("admin")) return false;
  // mentors can act; members on free are browse-only
  if (planId === "goalbuddy_free") return true;
  return false;
}

export function canBook(user: UserProfile | null | undefined) {
  if (!user) return false;
  return !user.browseOnly;
}

export function canAccessAdmin(user: UserProfile | null | undefined) {
  return !!user?.roles?.includes("admin");
}
